import { MapMarkerMainPropertyIcon } from "@avenue-8/sidekick-ui";
import { getPropertyStatusColor } from "../helpers/get-property-status-colors";
import { MapMarkerSvg } from "./MapMarkerSvg";
import styled from "@emotion/styled";

const MarkerContainer = styled.div`
  width: 39px;
  height: 44px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  top: -44px;
  left: -19.5px;
  z-index: 10;
  color: ${(p) => p.theme.text.colors.primary};
`;

const MarkerNumber = styled.div`
  position: absolute;
  left: 18px;
  top: 8px;
  font-size: 0.63rem;
  color: white;
`;

interface MapMarkerProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  propertyType: string;
  lat: number;
  lng: number;
  numProperties: number;
}

export const MapMarker = ({
  propertyType,
  lat: _lat,
  lng: _lng,
  numProperties,
  ...divProps
}: MapMarkerProps) => {
  return (
    <MarkerContainer {...(divProps as any)}>
      {numProperties > 1 ? <MarkerNumber>{numProperties}</MarkerNumber> : null}
      {propertyType === "subject" ? (
        <MapMarkerMainPropertyIcon />
      ) : (
        <MapMarkerSvg color={getPropertyStatusColor(propertyType)} />
      )}
    </MarkerContainer>
  );
};
